var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlechaLargaLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2444 4.25708H2.55439L5.53439 1.28038C5.82439 0.989727 5.82439 0.508644 5.53439 0.21799C5.24439 -0.0726635 4.76439 -0.0726635 4.47439 0.21799L0.214395 4.47758C0.154395 4.53771 0.104394 4.61789 0.0743945 4.68805C0.0643945 4.71812 0.0543945 4.73816 0.0443945 4.76823C0.0243945 4.82836 0.0143945 4.8885 0.00439453 4.94863C0.00439453 4.9787 0.00439453 4.99875 0.00439453 5.02882C0.00439453 5.109 0.0243945 5.18918 0.0543945 5.26936C0.0543945 5.26936 0.0543945 5.26936 0.0543945 5.27938C0.0943945 5.35956 0.144395 5.43974 0.204395 5.49988C0.204395 5.49988 0.204395 5.51992 0.224395 5.51992L4.48439 9.7795C4.63439 9.92984 4.82439 10 5.01439 10C5.20439 10 5.39439 9.92984 5.54439 9.7795C5.83439 9.48885 5.83439 9.00777 5.54439 8.71711L2.56439 5.74042H17.2544C17.6644 5.74042 18.0044 5.39965 18.0044 4.98872C18.0044 4.5778 17.6644 4.23703 17.2544 4.23703L17.2444 4.25708Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaLargaLeft);
export default __webpack_public_path__ + "static/media/flecha_larga_left.b6dc779a.svg";
export { ForwardRef as ReactComponent };